module.exports = __webpack_public_path__ + "static/media/plan_zh.fcd4d207.png";